export const FAQS_LIST_KEY = 'FAQS_LIST';
export const FAQS_ONE_KEY = 'FAQS_ONE_KEY';
